//Driver for single scores
//Intended to be accessed through teacher class management workflow

import axios from "axios";

export default {
	fa_icon: "fa-check",
	name: "Single Score",
	allowUpdateScore: true,
	showScores() {
		return false;
	},
	sidebarType() {
		return "normal";
	},
	canBeEscalated: true,

	enter(vue, assessmentID, itemID, classID, deliveryID, responseID) {
		let url = `/single_score/${assessmentID}/${itemID}/${classID}/${deliveryID}/${responseID}`;
		console.log("url", url);
		var query = { return: true };
		vue.$router.push({ path: url, query: query });
	},

	getNext(ctx) {
		let rid = ctx.response_id;
		var promise = axios.get(`/v3/response/${rid}`);
		promise.then(function(resp) {
			console.log("SingleSD GetNext:" + resp.data.response.ref_id);
		});
		return promise;
	},

	submitScore(score, response, keep) {
		score.response_id = response.id;

		var promise = axios.post("/v3/score", score, {
			params: { keep: keep }
		});
		promise.then(function(resp) {
			console.log("SingleSD Submitted");
		});
		return promise;
	}
};



// WEBPACK FOOTER //
// ./src/services/ScoringDrivers/SingleScoreDriver.js